export const goldenIdeas = [
  {
    path: '/goldenIdeas',
    label: '金点子列表',
    sort: '2-1',
    hidden: false,
    showMenus: false,
    component: () => import('@/views/goldenIdeas/index')
  },
  {
    path: '/goldenIdeas/detail',
    label: '金点子详情',
    sort: '2-1-1',
    hidden: true,
    showMenus: true,
    component: () => import('@/views/goldenIdeas/goldenldeas-detail'),
    meta: {
      guidePath: true,
      jumpPath: '/goldenIdeas'
    }
  }
]
